module.exports = __webpack_public_path__ + "static/media/feta_meli.46209e0e.jpg";